import {
  CommonModule,
  CurrencyPipe,
  DecimalPipe,
  PercentPipe,
} from '@angular/common';
import { NgModule } from '@angular/core';
import {
  AbbreviatedNumberWithSuffixPipe,
  AngularPipesModule,
} from '@aptitude/angular-pipes';
import { BasePanelCardComponent } from './base-panel-card/base-panel-card.component';
import { PanelCardComponent } from './panel-card/panel-card.component';
import { SummaryRollupCardComponent } from './summary-rollup-card/summary-rollup-card.component';
import { SummaryRollupWrapperComponent } from './summary-rollup-card/summary-rollup-wrapper/summary-rollup-wrapper.component';

@NgModule({
  declarations: [
    BasePanelCardComponent,
    PanelCardComponent,
    SummaryRollupCardComponent,
    SummaryRollupWrapperComponent,
  ],
  imports: [CommonModule, AngularPipesModule],
  exports: [
    PanelCardComponent,
    SummaryRollupCardComponent,
    SummaryRollupWrapperComponent,
  ],
  providers: [
    AbbreviatedNumberWithSuffixPipe,
    CurrencyPipe,
    DecimalPipe,
    PercentPipe,
  ],
})
export class PanelCardsModule {}
